import React from 'react';
import styles from './Reward.module.scss';
import { ReactComponent as StarIcon } from '@/assets/Icons/star.svg';

interface RewardProps {
  amount: number | string;
  showType?: boolean;
  type?: 'hearts' | 'stars';
}

export const Reward: React.FC<RewardProps> = ({ amount }) => {
  if (typeof amount === 'number') {
    if (amount <= 0) return null;
  }

  return (
    <div className={styles.ticketReward}>
      {amount}
      <StarIcon className={styles.starIcon} />
    </div>
  );
};
